import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=77680dce&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=77680dce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77680dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77680dce')) {
      api.createRecord('77680dce', component.options)
    } else {
      api.reload('77680dce', component.options)
    }
    module.hot.accept("./DocumentForm.vue?vue&type=template&id=77680dce&scoped=true", function () {
      api.rerender('77680dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/DocumentForm.vue"
export default component.exports